import { useSelector } from 'react-redux';
import { DialogSize } from '../../../../../../../react-commons/components/data-display/dialog/ResizableDialog';
import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import { QueryBaseComponent } from '../../../../../../../react-commons/query/QueryBaseComponent';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import {
    defaultImageAttachmentResource,
    ImageAttachmentMutationResourceSchema,
    useImageAttachmentActions,
} from '../../../../../resource/resources/artifacts/attachment/imageAttachmentResource';
import { EditChildBaseDialog } from '../../../../reusable-components/dialogs/EditChildBaseDialog';
import { Form_DisplayComponentBaseView } from '../../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { selectNoScopeValidationScope, selectReadOnly } from '../../../../util/useSelectorFunctions';
import { ImageAttachmentContent } from './ImageAttachmentContent';

export const ImageAttachmentEditDialog = ({
    onClose,
    objectId,
    versionedInId,
}: {
    onClose: () => void;
    objectId: string | undefined | null;
    versionedInId: string;
}) => {
    const readOnly = useSelector(selectReadOnly);
    const validationScope = useSelector(selectNoScopeValidationScope);

    const imageAttachmentActions = useImageAttachmentActions();
    const imageAttachmentQuery = imageAttachmentActions.useGetResourceByObjectIdAndVersionedIn(objectId, versionedInId);
    const updateImageAttachment = imageAttachmentActions.useUpdateResource();
    const validation = imageAttachmentActions.useValidateResource(imageAttachmentQuery.data?.id, validationScope);

    const { form, formNames, onSubmit } = useMyForm({
        schema: ImageAttachmentMutationResourceSchema,
        defaultValues: defaultImageAttachmentResource,
        submitHandler: async (data) => {
            await updateImageAttachment.mutateAsync({
                resource: data,
                id: data.id,
            });
        },
        reactiveValues: imageAttachmentQuery.data,
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Edit Image Attachment'}
            resourceType={ResourceType.IMAGE_ATTACHMENT}
            resourceValidationResult={validation.data}
            metaDataInfo={imageAttachmentQuery.data}
            dialogSize={DialogSize.MEDIUM_LARGE}
        >
            <QueryBaseComponent name="ImageAttachment" query={imageAttachmentQuery}>
                <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={false}>
                    <ImageAttachmentContent
                        form={form}
                        formNames={formNames}
                        readOnly={readOnly}
                        id={imageAttachmentQuery.data?.id}
                    />
                </Form_DisplayComponentBaseView>
            </QueryBaseComponent>
        </EditChildBaseDialog>
    );
};
